import { AxiosInstance } from "../utils/AxiosInstance";
import { CreditCardItem } from "js/components/Memberships/types";
import { PaginationTable } from "js/components/types";
import { CancelChargePayload, CreateChargePayload } from "js/pages/Payments/types";

export const getCards = async () => {
  const { data } = await AxiosInstance.get(`/v1/payments/cards`);
  return data;
};

export const createCard = async (values: CreditCardItem) => {
  const { data } = await AxiosInstance.post(`/v1/payments/cards/new`, values);
  return data;
};

export const updateCard = async (cardId: string) => {
  await AxiosInstance.patch(`/v1/payments/cards/${cardId}/update`, {
    is_default: true,
  });
};

export const deleteCart = async (cardId: string) => {
  await AxiosInstance.delete(`/v1/payments/cards/${cardId}/delete`);
};

export const getPaymentHistory = async (pagination: PaginationTable) => {
  const { data } = await AxiosInstance.get(`/v1/payments/history`, {
    params: {
      limit: pagination.pageSize,
      offset: (pagination.current - 1) * pagination.pageSize,
    },
  });
  return data;
};

export const getChargeInfo = async (
  resourceType: string,
  resourceId: string,
) => {
  const { data } = await AxiosInstance.get(
    `/v1/payments/charge-info/${resourceType}/${resourceId}`,
  );
  return data;
};

export const createCharge = async (payload: CreateChargePayload) => {
  const { data } = await AxiosInstance.post(`/v1/payments/create-charge`, payload);
  return data;
};

export const cancelCharge = async (payload: CancelChargePayload) => {
  const { data } = await AxiosInstance.post(`/v1/payments/cancel-charge`, payload);
  return data;
};

// Web Check upsell payment endpoints
export const getWebCheckChargeInfo = async (webCheckId: string) => {
  const { data } = await AxiosInstance.get(
    `/v1/web-checks/${webCheckId}/charge-info`,
  );
  return data;
};

export const createWebCheckCharge = async (webCheckId: string, method: string) => {
  const { data } = await AxiosInstance.post(
    `/v1/web-checks/${webCheckId}/create-charge`,
    { method },
  );
  return data;
};

export const cancelWebCheckCharge = async (webCheckId: string) => {
  const { data } = await AxiosInstance.post(
    `/v1/web-checks/${webCheckId}/cancel-charge`,
  );
  return data;
};
